<template>
    <div v-if="isOutsideLabel" class="outside-btn clickable" @click="click">
        <span class="outside-btn__label" :style="`color: ${labelColor};`" :class="`${uppercase? 'outside-btn__btn--uppercase': ''}`" v-if="label">{{label}}</span>
        <v-btn elevation="0" :color="color" class="outside-btn__btn" >
            <v-icon v-if="icon" :style="`color: ${iconColor};`">{{icon}}</v-icon>
        </v-btn>
    </div>
    <v-btn v-else :color="color" :class="`${uppercase? 'btn--uppercase': ''}`" @click="click">
            <v-icon v-if="icon" :style="`color: ${iconColor};`">{{icon}}</v-icon>
            <span v-if="label" :style="`color: ${labelColor};`">{{label}}</span>
        </v-btn>
</template>

<script>
  export default {
    name: 'Button',
    props:{
      type: {
        type: String, 
        default: 'btn'
      },
      label:{
        type: String
      },
      icon: {
        type: String
      }, 
      iconColor: {
        type: String,
        default: '#fff'
      },
      color: {
        type: String,
        default: '#666666'
      },
      labelColor:{
        type:String,
        default: '#878889'
      },
      uppercase:{
        type: Boolean,
        default: true
      }
    },
    computed:{
      isOutsideLabel(){
        return this.type === 'outside-label';
      },
    },
    methods:{
      click(){
        this.$emit('click');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .outside-btn{

    &__label{
      font-family: Arial, sans-serif!important;
      font-weight: 700!important;
      line-height: 13.8px;
      letter-spacing: 1px;
      font-size: 12px!important;
      margin-right: 1.25em;
    }

    &__btn{
      height: auto!important;
      min-width: auto!important;
      padding: .5em!important;
      display: inline-block;

      &--uppercase{
        text-transform: uppercase;
      }
    }
  }
  .btn{
    &--uppercase{
      text-transform: uppercase;
    }
  }
</style>
